import React, { useRef, useEffect, useState } from "react";
import { Modal } from "antd";
import { Player } from "video-react";
import Helper from "../../Helper";
import _ from "lodash";
import "video-react/dist/video-react.css";

export default function VideoPlayer({ visible, setVisible, path, setPath, title }) {

    const player = useRef()

    const [videoPlayer, setVideoPlayer] = useState(<></>)

    function onClose() {
        setVisible(false)
        setPath('')
    }

    function pause() {
        player.current.pause();
    }

    useEffect(() => {
        if (_.isEmpty(path)) {
            setVideoPlayer(<></>)
        }
        else {
            setVideoPlayer(
                <Player
                    autoPlay
                    ref={ref => {
                        player.current = ref;
                    }}
                >
                    <source
                        src={Helper.generateImageURL(path)}
                        type="video/mp4"
                    />
                </Player>
            )
        }

    }, [path])

    return (
        <Modal
            title={title || "Video"}
            open={visible}
            footer={null}
            onCancel={onClose}
            afterClose={pause}
            bodyStyle={{ padding: 0 }}
            preload='none'
        >
            {videoPlayer}
        </Modal>
    );

}
